import { useRecoilValue, useSetRecoilState } from "recoil"
import { usePictureInPicture } from "../hooks/usePictureInPicture"
import { playerPropsSelector } from "../recoil/atoms/player"
import { roomCallbackSelector } from "../recoil/atoms/room"
import {
  setWatchPartySelector,
  watchPartyHostIdSelector
} from "../recoil/atoms/watchPartyScreen"
import { taggedBadgesAtom } from "../recoil/atoms/taggedBadges"
import { shoppableMNPVideoAtom } from "../recoil/atoms/shoppableVideos"
interface WatchPartyReturn {
  startServerWatchParty: () => Promise<boolean>
  stopServerWatchParty: () => Promise<void>
  setWatchPartyScreenProps: (
    enabled: boolean,
    url: string,
    hostId?: string
  ) => void
}

const useServerWatchParty = (): WatchPartyReturn => {
  const setPlayerProps = useSetRecoilState(playerPropsSelector)
  const roomCallback = useRecoilValue(roomCallbackSelector)
  const { exitPictureInPicture } = usePictureInPicture()
  const setWatchPartyHostId = useSetRecoilState(watchPartyHostIdSelector)
  const setWatchParty = useSetRecoilState(setWatchPartySelector)
  const MeetOnline = window.MeetOnline
  const setShoppableMNPVideo = useSetRecoilState(shoppableMNPVideoAtom)
  const setTaggedBadges = useSetRecoilState(taggedBadgesAtom)
  const setWatchPartyScreenProps = (
    enabled: boolean,
    link: string,
    hostId?: string
  ) => {
    setWatchParty({ hostId, link, enabled })
  }

  const startServerWatchParty = async () => {
    const _roomData = await roomCallback.handleReturnData()
    let wpHostId = MeetOnline?.client().rtc?.getWatchPartyHostId()

    if (
      _roomData?.branding?.enableModNotPresentVideo &&
      _roomData?.branding?.modNotPresentVideo !== ""
    ) {
      if (wpHostId === "modNotPresentVideo") {
        return false
      }
      // do not start SERVER watch party (VIDEO) if local user is a MODERATOR and join room with CAM/MIC enabled - PENDING
      await MeetOnline?.client().rtc?.toggleWatchParty(
        _roomData?.branding?.modNotPresentVideo,
        "modNotPresentVideo"
      )
    } else if (
      _roomData?.branding?.enableModNotPresentImage &&
      _roomData?.branding?.modNotPresentImage !== ""
    ) {
      if (wpHostId === "modNotPresentImage") {
        return false
      }
      // do not start SERVER watch party (IMAGE) if local user is a MODERATOR and join room with CAM/MIC enabled - PENDING
      await MeetOnline?.client().rtc?.toggleWatchParty(
        _roomData?.branding?.modNotPresentImage,
        "modNotPresentImage"
      )
    } else {
      if (wpHostId === "modNotPresentOverlay") {
        // return false
      }
      await MeetOnline?.client().rtc?.toggleWatchParty(
        "noSource",
        "modNotPresentOverlay"
      )
    }
  }

  const stopServerWatchParty = async () => {
    setWatchPartyScreenProps(false, "")
    setWatchPartyHostId("")
    exitPictureInPicture()
    setPlayerProps({ isControlVolume: false })
    setTaggedBadges([])
    setShoppableMNPVideo({
      idShoppableMNP: "",
      enabledShoppableMNP: false,
      srcShoppableMNP: "",
      typeShoppableMNP: ""
    })
    await MeetOnline?.client().rtc?.stopWatchParty()
  }

  return {
    startServerWatchParty,
    stopServerWatchParty,
    setWatchPartyScreenProps
  }
}

export default useServerWatchParty
